<template>
    <div class="container pt-12 pb-20">
        <SectionIntro :title="$t('cookies.privacy_policy')" />
        <div class="grid grid-cols-12">
            <div
                class="tinymce-content mt-8 col-span-12 lg:col-span-8 lg:col-start-3"
                v-html="model.translations[0].text"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    async asyncData({ $axios, params, error }) {
        let model = null;

        try {
            await $axios
                .$get(`/page/adatvedelmi-tajekoztato`)
                .then((res) => {
                    if (res) {
                        model = res.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }
        return { model };
    },
    head() {
        const meta = [
            {
                hid: 'og:title',
                property: 'og:title',
                content: this.$t('cookies.privacy_policy'),
            },
            {
                hid: 'title',
                name: 'title',
                content: this.$t('cookies.privacy_policy'),
            },
            {
                hid: 'og:description',
                property: 'og:description',
                content: this.$t('cookies.privacy_policy'),
            },
            {
                hid: 'description',
                name: 'description',
                content: this.$t('cookies.privacy_policy'),
            },
        ];

        return {
            title: this.$t('cookies.privacy_policy'),
            meta,
        };
    },
};
</script>
